<template>
  <div style="display: flex; align-items: center">
    <span style="margin-right: 10px; width: 100px"> {{ i18nJS.relatives.index.title }} </span>
    <!-- usare v-select2 con :selectConfig così non va bene -->
    <v-select2
      @input="selectRequirement($event)"
      :multiple="false"
      data-allow-clear="true"
      :disabled="!guest_id"
      :options-list="requirementResult()"
      data-minimumInputLength="0"
      data-pageLimit="20"
      id="requirement_relatives_id"
    >
    </v-select2>
    <spinner :visible="isLoading"></spinner>
  </div>
</template>

<script>
import vSelect2 from '../../vSelect2';
import apiConnector from '@/epersonam/apiConnector';
import spinner from '../../spinner';

export default {
  name: 'relativeRequirement',
  props: ['buId', 'index', 'params'],
  components: {
    vSelect2,
    spinner,
  },
  data() {
    return {
      isLoading: false,
      result: null,
      url: '/it/guests',
      guest_id: null,
      relatives: [],
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  mounted() {
    eventBus.$on('guestRequirementSelected', (guest_id) => {
      this.isLoading = true;
      this.guest_id = null;
      this.relatives = [];
      apiConnector()
        .get(`${this.url}/${guest_id}/relatives.json?business_unit_id=${guest_id}`)
        .then((res) => {
          this.isLoading = false;
          this.guest_id = guest_id;
          this.relatives = res.data;
        });
    });
  },
  methods: {
    requirementResult() {
      return this.relatives.map((r) => [`${r.firstname} ${r.surname}`, r.id]);
    },
    selectRequirement(i) {
      const data_selected = $('#requirement_relatives_id').select2('data')[0];
      this.$emit('selected', { data_selected: this.relatives.find((r) => r.id == i), index: this.index });
    },
  },
};
</script>

<style lang="scss" scoped></style>
